function fromBase64Url(value: unknown): ArrayBuffer {
  const normalized = String(value || '').replace(/-/g, '+').replace(/_/g, '/');
  const binary = atob(normalized + '='.repeat((4 - normalized.length % 4) % 4));
  return Uint8Array.from(binary, (character) => character.charCodeAt(0)).buffer;
}

function toBase64Url(value: ArrayBuffer): string {
  const bytes = new Uint8Array(value);
  let binary = '';
  bytes.forEach((item) => { binary += String.fromCharCode(item); });
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

export function normalizePasskeyCreationOptions(value: Record<string, unknown>): PublicKeyCredentialCreationOptions {
  const options = structuredClone(value) as Record<string, any>;
  options.challenge = fromBase64Url(options.challenge);
  options.user = { ...options.user, id: fromBase64Url(options.user?.id) };
  options.excludeCredentials = Array.isArray(options.excludeCredentials)
    ? options.excludeCredentials.map((item: Record<string, unknown>) => ({ ...item, id: fromBase64Url(item.id) }))
    : [];
  return options as PublicKeyCredentialCreationOptions;
}

export function normalizePasskeyRequestOptions(value: Record<string, unknown>): PublicKeyCredentialRequestOptions {
  const options = structuredClone(value) as Record<string, any>;
  options.challenge = fromBase64Url(options.challenge);
  options.allowCredentials = Array.isArray(options.allowCredentials)
    ? options.allowCredentials.map((item: Record<string, unknown>) => ({ ...item, id: fromBase64Url(item.id) }))
    : undefined;
  return options as PublicKeyCredentialRequestOptions;
}

export function serializePasskeyCredential(value: Credential): Record<string, unknown> {
  const credential = value as PublicKeyCredential;
  const response = credential.response;
  const common = {
    id: credential.id,
    rawId: toBase64Url(credential.rawId),
    type: credential.type,
    authenticatorAttachment: credential.authenticatorAttachment,
    clientExtensionResults: credential.getClientExtensionResults(),
  };
  if (response instanceof AuthenticatorAttestationResponse) {
    return {
      ...common,
      response: {
        clientDataJSON: toBase64Url(response.clientDataJSON),
        attestationObject: toBase64Url(response.attestationObject),
        transports: response.getTransports?.() || [],
      },
    };
  }
  const assertion = response as AuthenticatorAssertionResponse;
  return {
    ...common,
    response: {
      clientDataJSON: toBase64Url(assertion.clientDataJSON),
      authenticatorData: toBase64Url(assertion.authenticatorData),
      signature: toBase64Url(assertion.signature),
      userHandle: assertion.userHandle ? toBase64Url(assertion.userHandle) : null,
    },
  };
}
